import { LanguageSelect } from '@/pages/agents/components/LanguageSelect';
import { AGENT_DEFAULT_NAME, AGENT_NAME_MAX_LENGTH, AGENT_NAME_PLACEHOLDER } from '@/pages/agents/constants';
import { useAgentEditorStore } from '@/state/root';
import theme from '@/theme';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useCallback } from 'react';
import { ContentContainer, StyledTextField, SubTitle, Title, TitleContainer } from '../../common';
import { VoiceButton } from './VoiceButton';

const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
`;

const FieldLabel = styled.label`
    display: flex;
    align-items: center;

    gap: 2px;

    margin-bottom: 4px;

    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.28px;
    line-height: 20px;

    color: ${theme.colors.secondary.main};
`;

export const AgentIdentity = observer(() => {
    const agentEditorStore = useAgentEditorStore();

    const onAgentNameChange = useCallback((e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (e.target.value.length < AGENT_NAME_MAX_LENGTH) {
            agentEditorStore.setInputAgent(prev => ({ ...prev, preview_name: e.target.value }));
        }
    }, []);

    return (
        <ContentContainer>
            <TitleContainer>
                <Title>Setup your agent</Title>
                <SubTitle>Personalize your agent’s identity and voice</SubTitle>
            </TitleContainer>

            <FormContainer>
                <div>
                    <FieldLabel>Agent name</FieldLabel>
                    <StyledTextField
                        placeholder={AGENT_NAME_PLACEHOLDER}
                        value={agentEditorStore.inputAgent.preview_name}
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: false }}
                        onChange={onAgentNameChange}
                        onBlur={() => {
                            if (agentEditorStore.inputAgent.preview_name === '') {
                                agentEditorStore.setInputAgent(prev => ({ ...prev, preview_name: AGENT_DEFAULT_NAME }));
                            }
                        }}
                    />
                </div>

                <div>
                    <FieldLabel>Language</FieldLabel>
                    <LanguageSelect />
                </div>

                <div>
                    <FieldLabel>Voice</FieldLabel>
                    <VoiceButton />
                </div>
            </FormContainer>
        </ContentContainer>
    );
});
